import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { logoutUser, navigate } from 'actionCreators';
import RouterLink from 'components/RouterLink';
import { AppBar, Drawer, IconButton, ListItem, FontIcon, List } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import MediaQuery from 'react-responsive';
import ProfileMenu from './profileMenu';
import SearchBox from 'components/SearchBox';
import { NAV_CUT_POINT, ALLOWED_DASHBOARD_POSITIONS, ALLOWED_DASHBOARD_NAMES } from 'config/constants';
import { can } from '../../../services';
import Mousetrap from 'mousetrap';
import RTListTheme from 'react-toolbox/lib/list/theme';
import RTAppBar from './appBar';
import RTNavigation from './navigation';
import RTButton from './button';
import RTLink from './link';
import SearchTheme from './search';
import { urls } from 'helpers/url';

const theme = { RTAppBar, RTNavigation, RTButton, RTLink };
class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.moveDrawer = () => { this.setState({ drawerOpen: !this.state.drawerOpen }); };
    this.toggleSubItems = this.toggleSubItems.bind(this);
    this.state = { drawerOpen: false, administration: false, selectedNavTab: '' };
  }

  componentDidMount = () => {
    this.getInitialSelectedTabFromURL();
    Mousetrap.bind('g+l', this.handleFiltersShortcut);
    Mousetrap.bind('g+s', this.handleScheduleShortcut);
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const newWindow = window.open(`/phases?query=${value}`, '_blank');
    newWindow.ignoreLocationFilters = false;
    return newWindow;
  }

  setSelectedNavTab = id => this.setState({ selectedNavTab: id });

  getInitialSelectedTabFromURL = () => {
    const url = window.location.href;
    if (url.includes('/schedule')) this.setSelectedNavTab('Schedule');
    else if (
      url.includes('/employees')
      || url.includes('/iqms')
      || url.includes('/estimators')
      || url.includes('/installers')
    ) this.setSelectedNavTab('User Management');
    else if (
      url.includes('/stores')
      || url.includes('/workrooms')
      || url.includes('/pricepatchuploads')
      || url.includes('/bulk-updates')
      || url.includes('/lowes-survey')
      || url.includes('/line-items')
      || url.includes('/default-installer-pay')
      || url.includes('/holiday-promo-settings')
    ) this.setSelectedNavTab('Administration');
    else if (
      url.includes('/tools')
      || url.includes(urls.activity())
      || url.includes(urls.installerPaperwork())
      || url.includes(urls.warehouseReport())
      || url.includes(urls.scraper())
      || url.includes(urls.tags())
    ) this.setSelectedNavTab('Tools');
    else this.setSelectedNavTab('Filters');
  }

  handleFiltersShortcut = () => this.props.navigate('/phases')
  handleScheduleShortcut = () => this.props.navigate('/schedule')

  adminSubItems = () => {
    const items = [
      { label: 'Store Management', linkTo: '/stores', ability: 'store' },
      { label: 'Workroom Management', linkTo: '/workrooms', ability: 'workroom' },
      { label: 'Bulk Update', linkTo: '/bulk-updates', ability: 'bulk_update_upload' },
      { label: 'Margin Update', linkTo: '/margin-updates', ability: 'margin_upload' },
      { label: 'Activity Update', linkTo: '/activity-updates', ability: 'activity_upload' },
      { label: 'Line Items', linkTo: '/line-items', ability: 'line_item' },
    ];
    const mvw = this.props.user.manage_vendor_workrooms;
    if (mvw.lhi || mvw.ifi) {
      items.push({ label: 'Holiday Promo Settings', linkTo: '/holiday-promo-settings', ability: 'holiday_promo_settings' });
    }
    if (mvw.lhi) {
      items.push({ label: 'Price Patches', linkTo: '/pricepatchuploads', ability: 'price_patch_upload' });
      items.push({ label: 'Lowes C&P', linkTo: '/lowes-survey', ability: 'lowes_survey_upload' });
    }
    if (mvw.ifi && can(this.props.user.role, 'view', 'default_installer_pay')) {
      items.push({ label: 'Default Installer Pay', linkTo: '/default-installer-pay', ability: 'default_installer_pay' });
    }
    return items;
  };

  menuItems = () => ([
    { label: 'Phases', key: 'phases', linkTo: '/phases', ability: 'phase' },
  // { label: 'Dashboard', key: 'dashboard', linkTo: '/dashboard', ability: 'dashboard' },
    { label: 'Schedule', key: 'schedule', linkTo: '/schedule', ability: 'schedule' },
    {
      label: 'User Management',
      key: 'users',
      linkTo: '/employees',
      subItems: [
        { label: 'Employees', linkTo: '/employees', ability: 'employee' },
        // { label: 'IQMs', linkTo: '/iqms', ability: 'iqm' },
        { label: 'Estimators', linkTo: '/estimators', ability: 'estimator' },
        { label: 'Installers', linkTo: '/installers', ability: 'installer', except: 'installer' },
      ],
    },
    {
      label: 'Administration',
      key: 'administration',
      linkTo: '/stores',
      subItems: this.adminSubItems(),
    },
    {
      label: 'Tools',
      key: 'tools',
      linkTo: urls.activity(),
      subItems: [
        { label: 'Employee Activity', linkTo: urls.activity(), ability: 'activity_report' },
        { label: 'Installations Paperwork', linkTo: urls.installerPaperwork(), ability: 'installations_paperwork' },
        { label: 'Warehouse Report', linkTo: urls.warehouseReport(), ability: 'warehouse_report' },
        { label: 'Install/Workorder Report', linkTo: urls.installWorkorderReport(), ability: 'warehouse_report' },
        { label: 'Job History', linkTo: urls.jobHistory(), ability: 'job_history' },
        { label: 'Tags Bulk Print', linkTo: urls.tags(), ability: 'tags_bulk_print' },
        { label: 'Bulk Project Load', linkTo: '/bulk-projects', ability: 'bulk_projects_load' },
        { label: 'Scraper', linkTo: urls.scraper(), ability: 'scraper' },
      ],
    },
  ]);

  determinePerms = (ability, except) => {
    const { role, position } = this.props.user;
    return role !== except && (ability === 'bulk_projects_load' ?
      can(role, 'manage', ability, { position }) : can(role, 'view', ability));
  };

  items = (items = this.menuItems()) => items.map((item) => {
    const { role, manage_vendor_workrooms: mvw } = this.props.user;
    if (item.subItems) {
      const available = this.items(item.subItems);
      if (!available.length) return null;
      if (item.label === 'Administration' && mvw.ifi) {
        return { ...item, subItems: available.map(i => (i.label === 'Workroom Management' ? { ...i, label: 'Market/Workroom Management' } : i)) };
      } if (item.label === 'Tools' && mvw.ifi && !can(role, 'view', 'non_ifi', { manage_vendor_workrooms: mvw })) {
        const filtered = available.filter(i => !['Warehouse Report', 'Tags Bulk Print', 'Scraper'].includes(i.label));
        return { ...item, subItems: filtered };
      }
      return { ...item, subItems: available };
    }
    return !item.ability || this.determinePerms(item.ability, item.except) ? item : null;
  }).filter(i => !!i);

  toggleSubItems = menuKey => (ev) => {
    ev.preventDefault();
    const statePiece = {};
    statePiece[menuKey] = !this.state[menuKey];
    this.setState(statePiece);
  };

  subMenuLink = (item, type = 'horizontal') => (<RouterLink
    className={RTLink.navLink}
    to={item.linkTo}
    onClick={type === 'vertical' ? this.moveDrawer : null}
  >
    <span className={RTListTheme.itemContentRoot}>
      <span className={RTListTheme.itemText}>{item.label}</span>
    </span>
  </RouterLink>);

  subItems = (items, type = 'horizontal') => (items ? (<div
    className={type === 'horizontal' ? RTButton.subMenuHorizontal : RTButton.subMenuVertical}
  >
    <List selectable>
      {items.map((item) => {
        if (type === 'horizontal') {
          return (<ListItem
            key={item.label}
            value={item.label}
            itemContent={this.subMenuLink(item)}
            className={RTAppBar.sublinkDesktop}
          />);
        }
        return (<ListItem
          key={item.label}
          value={item.label}
          itemContent={this.subMenuLink(item, 'vertical')}
          className={RTAppBar.sublink}
        />);
      })}
    </List>
  </div>) : null);


  filterMenuItems = () => {
    const { position, name: userName } = this.props.user;
    const filteredMenuItems = this.items().filter((menuItem) => {
      if (menuItem.label === 'Dashboard') {
        if (ALLOWED_DASHBOARD_POSITIONS.includes(position) ||
            ALLOWED_DASHBOARD_NAMES.includes(userName)) return true;
        return false;
      }
      return true;
    });
    return filteredMenuItems;
  }

  renderDesktop = () => {
    const filteredMenuItems = this.filterMenuItems();
    const buttonMenuItems = filteredMenuItems.map((menuItem) => {
      const className = menuItem.label === this.state.selectedNavTab ?
      `${RTButton.neutral} ${RTButton.selected}` : RTButton.neutral;
      return (<li // eslint-disable-line
        key={menuItem.label}
        className={className}
        onClick={() => this.setSelectedNavTab(menuItem.label)}
      >
        <RouterLink to={menuItem.linkTo || ''} className={RTLink.navLink}>{menuItem.label}</RouterLink>
        {menuItem.subItems != null ? this.subItems(menuItem.subItems) : null}
      </li>);
    });
    const onPhases = this.props.location.pathname === '/phases';
    return (<ThemeProvider theme={theme}>
      <AppBar flat>
        <ul className={RTAppBar.navList}>
          {buttonMenuItems}
        </ul>
        {!onPhases && <SearchBox
          onSubmit={this.onSearch}
          placeholder="Search phases in new tab"
          theme={SearchTheme}
        />}
        <ProfileMenu
          user={this.props.user}
          logoutUser={this.props.logoutUser}
        />
      </AppBar>
    </ThemeProvider>);
  }

  renderMobile = () => {
    const filteredMenuItems = this.filterMenuItems();
    const linkMenuItems = filteredMenuItems.map((menu) => {
      if (menu.subItems != null) {
        return (<li key={menu.key}>
          <a href={menu.linkTo} onClick={this.toggleSubItems(menu.key)} style={{ display: 'flex', alignItems: 'center' }}>
            <span>{menu.label}</span>
            <FontIcon style={{ flexGrow: '1' }} value={this.state[menu.key] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
          </a>
          {this.state[menu.key] && this.subItems(menu.subItems, 'vertical')}
        </li>);
      }
      const menuItem = (<RouterLink className={RTLink.navLink} to={menu.linkTo || ''} onClick={this.moveDrawer} key={menu.key}>{menu.label}</RouterLink>);
      return (<li key={menu.key}>{menuItem}</li>);
    });
    return (<ThemeProvider theme={theme}>
      <Fragment>
        <Drawer active={this.state.drawerOpen} onOverlayClick={this.moveDrawer}>
          <ul className={RTAppBar.navListMobile}>
            {linkMenuItems}
          </ul>
        </Drawer>
        <AppBar className={RTAppBar.small}>
          <IconButton icon="menu" inverse onClick={this.moveDrawer} />
          <div style={{ position: 'absolute', right: '0', top: '0' }} />
          <ProfileMenu
            user={this.props.user}
            logoutUser={this.props.logoutUser}
          />
        </AppBar>
      </Fragment>
    </ThemeProvider>);
  }

  render = () => {
    const onPhases = this.props.location.pathname === '/phases';
    const searchBoxSize = 216;
    const dynamicNavCutPoint = onPhases ? NAV_CUT_POINT - searchBoxSize : NAV_CUT_POINT;
    return (<Fragment>
      <MediaQuery maxWidth={dynamicNavCutPoint - 1}>
        {this.renderMobile()}
      </MediaQuery>
      <MediaQuery minWidth={dynamicNavCutPoint}>
        {this.renderDesktop()}
      </MediaQuery>
    </Fragment>);
  }
}

NavigationBar.defaultProps = { user: { role: '', position: '', name: '' } };

NavigationBar.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
    position: PropTypes.string,
    name: PropTypes.string,
    employable_id: PropTypes.string,
    employable_type: PropTypes.string,
    manage_vendor_workrooms: PropTypes.object,
    isAuthenticating: PropTypes.bool,
  }),
  employee: PropTypes.object,
  logoutUser: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, { logoutUser, navigate })(NavigationBar);



// WEBPACK FOOTER //
// ./client/app/shared/components/NavigationBar/index.jsx